import { render, staticRenderFns } from "./createList.vue?vue&type=template&id=3a5cc1e5&scoped=true"
import script from "./createList.vue?vue&type=script&lang=js"
export * from "./createList.vue?vue&type=script&lang=js"
import style0 from "./createList.vue?vue&type=style&index=0&id=3a5cc1e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5cc1e5",
  null
  
)

export default component.exports